
import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { 
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

export function UserProfileSection() {
  const { user, logout } = useAuth();
  const { state } = useSidebar();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  
  if (!user) return null;
  
  // Get initials for avatar fallback
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const handleLogout = async () => {
    setOpen(false);
    await logout();
  };

  const isCollapsed = state === "collapsed";

  return (
    <div className="border-t border-sidebar-border p-3">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button 
            variant="ghost" 
            className={cn(
              "flex w-full h-auto items-center gap-3 rounded-md p-2 text-left hover:bg-sidebar-accent/50 transition-colors",
              isCollapsed && "justify-center p-1"
            )}
          >
            <Avatar className={cn("h-8 w-8 shrink-0", isCollapsed && "h-6 w-6")}>
              {user.profileImage ? (
                <AvatarImage src={user.profileImage} alt={user.name} />
              ) : user.companyLogo ? (
                <AvatarImage src={user.companyLogo} alt={user.name} />
              ) : (
                <AvatarFallback className="bg-sidebar-primary text-sidebar-primary-foreground text-xs">
                  {user.name ? getInitials(user.name) : "U"}
                </AvatarFallback>
              )}
            </Avatar>
            {!isCollapsed && (
              <div className="min-w-0 flex-1 transition-opacity duration-200">
                <p className="truncate text-sm font-medium text-sidebar-foreground">{user.name}</p>
                <p className="truncate text-xs text-sidebar-foreground/70">{user.email}</p>
              </div>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-56 p-2" side="top" align="start" sideOffset={5}>
          <Button
            onClick={handleLogout}
            variant="ghost"
            size="sm"
            className="flex w-full items-center gap-2 rounded-md"
          >
            <LogOut className="h-4 w-4" />
            <span>Sair</span>
          </Button>
        </PopoverContent>
      </Popover>
    </div>
  );
}
